/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";

export class StarStruckGameAssets {

 public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static GAME_PANEL:string = "gamePanel";
    public static MULTIPLIER:string = "W";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(StarStruckGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("numbersWinMultiplier", "fonts/bitmapfonts/NumbersWinMultiplier.fnt"),
                    new BitmapFontAsset("numbersWinCountUpBlink", "fonts/bitmapfonts/NumbersWinCountUpBlink.fnt"),
                    new BitmapFontAsset("numbersWinCountUp_disabled", "fonts/bitmapfonts/NumbersWinCountUp_disabled.fnt")
                ]
            },
            {
                name : "introJpeg",
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                ]
            }
        ],

        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json")
                ],
                animations: {
                    "gamePanel": "Game_Reels",
                    "betline_1": "Betline/Betline_1",
                    "betline_2": "Betline/Betline_2",
                    "betline_3": "Betline/Betline_3",
                    "betline_4": "Betline/Betline_4",
                    "betline_5": "Betline/Betline_5",
                    "B_pick": "B_pick",
                    "B_pick_disabled": "B_pick_disabled",
                    "bonusStar": "Bonus_Star/BonusStar_000",
                    "bonusShuffle": "Bonus_Shuffle/Bonus_Shuffle_",
                    "bigWinText0": "bigwin/BW_1",
                    "bigWinText1": "bigwin/BW_2",
                    "bigWinText2": "bigwin/BW_3",
                    "bigWinCoin0": "bigwin/coinCopper/CoinCopper_",
                    "bigWinCoin1": "bigwin/coinSilver/CoinSilver_",
                    "bigWinCoin2": "bigwin/coinGold/CoinGold_",
                    "button": "ui/gameTweakerButton/button",
                    "button-disabled": "ui/gameTweakerButton/button-disabled"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json")
                ],
                animations: {
                    "mainBackground": "Game_BG",
                    "starContainer": "FX_Sym_Win/FX_Sym_Win_00029",
                    "winSplash": "FX_Explosion/FX_Explosion_",
                    "winStar": "Win_FX/Win_FX_StarSplash_",
                    "hotZone": "FX_HotZone_A/FX_HotZone_A_",
                    "hotZoneWin": "FX_HotZone/FX_HotZone_",
                    "reelExcitement": "Reel_Excitement/Reel_Excitement_",
                    "bigWinTextStar": "FX_BW_Stars/FX_BW_Stars_",
                    "bigWinTextEffect0": "FX_BW1/FX_BW_1_000",
                    "bigWinTextEffect1": "FX_BW2/FX_BW_2_000",
                    "bigWinTextEffect2": "FX_BW3/FX_BW_3_000",
                    "symWinBgAnimation": "FX_Sym_Win/FX_Sym_Win_",
                    "symIdleAnimation": "FX_Symbol_Idle/FX_Sym_Idle_"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            }
        ]
    }
}